export default "__VITE_ASSET__DblRhJDF__"